import * as React from "react";

const RedCross = (props) => {
  return (
    <svg className={props.className} style={{cursor:"pointer", alignSelf:"center"}} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <defs>
    </defs>
    <g transform="translate(-263 -457)">
    <rect className="a" fill="#c32525" width="14" height="14" rx="2" transform="translate(263 457)"/>
    <g transform="translate(267 461)">
    <line className="b" fill="none" stroke="#fff" x2="6" y2="6"/>
    <line className="b" fill="none" stroke="#fff" x1="6" y2="6"/>
    </g>
    </g>
    </svg>
  );
}

export default RedCross;
